module.exports = __webpack_public_path__ + "img/hotels-3.43809f7a.png";